import PhotoWrapper from '../src/PhotoWrapper.tsx';
export default PhotoWrapper;
